import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'
import gql from 'graphql-tag'

export interface VisitureInstagramPostsQueryObject {
  __args: {
    image_quantity: string
  }
  items: {
    instagram_images: {
      width: boolean
      height: boolean
      url: boolean
      [key: string]: any
    }
    caption: boolean
    [key: string]: any
  }
}

export const visitureInstagramPostsQueryObject = {
  __args: {
    image_quantity: '%{limit}'
  },
  items: {
    instagram_images: {
      width: true,
      height: true,
      url: true
    },
    caption: true
  }
}

interface VisitureInstagramPostsQueryInput {
  limit: number
}

export type GetVisitureInstagramPostsQuery = (input: VisitureInstagramPostsQueryInput) => Promise<ApolloQueryResult<any>>

export const createVisitureInstagramPostsQuery = ({ getQueries }: ServiceDependencies): GetVisitureInstagramPostsQuery => async (input) => {
  const query = getQueries().visitureInstagramPostQuery
  query.__args.image_quantity = input.limit.toString()

  return apolloClient.query({ query: gql`${jsonToGraphQLQuery(query)}`, errorPolicy: 'ignore' })
}
